import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.custom-fields-form', () => {
  void import('./internal/custom-fields-form').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.scout-report-measurement-type-form', () => {
  void import('./internal/scout-report-measurement-type-form')
    .then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.unit-form', () => {
  void import('./internal/unit-form').then(({ default: Component }) => Component());
});
